<div class="cyber-menu surface">
  <div class="menu-header">
    <span class="cyber-title">>_ DATA_MASTERS</span>
  </div>
  <ul>
    <li *ngFor="let entity of entities" 
        (click)="selectEntity(entity.instance); activeMenu = entity.name"
        [class.active]="activeMenu === entity.name">
      {{ entity.name }}
    </li>
  </ul>
</div>